<template>
  <div>
    <Title :pages="[{ icon: 'scale-balanced', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <!-- Filtros -->
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12 elevation-0" style="background: white">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-combobox v-model="emitter_selected" autocomplete="off" item-text="name" item-value="id" :items="emitters" label="Emisor" class="pt-0 mt-0" return-object></v-combobox>
                </div>

                <div class="col-md-2 pt-0">
                  <v-menu
                    ref="desde_menu"
                    v-model="desde_menu"
                    :close-on-content-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_menu = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.desde_menu.save(desde_selected)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-2 pt-0">
                  <v-menu
                    ref="hasta_menu"
                    v-model="hasta_menu"
                    :close-on-content-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_menu = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_menu.save(hasta_selected)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-2 pt-0">
                  <v-combobox v-model="cost_center_selected" autocomplete="off" item-text="name" item-value="id" :items="cost_centers" label="Centro de Costo" class="pt-0 mt-0" clearable></v-combobox>
                </div>

                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="info" :disabled="!emitter_selected" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <!-- Estado de Resultados -->
      <v-card>
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" small outlined class="mr-2" :disabled="loading || !data" @click="toggleAll">
            {{ allExpanded ? "Colapsar todo" : "Expandir todo" }}
          </v-btn>
          <v-btn color="blue-grey" small dark :loading="dialog_export" :disabled="loading || !data" @click="exportFile"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
        </v-card-title>

        <v-progress-linear v-if="loading" indeterminate color="info"></v-progress-linear>

        <div class="pa-2" style="overflow-x: auto">
          <div v-if="loading" class="pa-6 text-center grey--text">Cargando...</div>

          <div v-else-if="data">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Código</th>
                    <th class="text-left">Cuenta</th>
                    <th class="text-right">Importe</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="grupo in grupos">
                    <tr :key="grupo.key + '-h'" class="grey lighten-4">
                      <td colspan="3" class="font-weight-bold">{{ grupo.title }}</td>
                    </tr>

                    <template v-for="row in rowsByGrupo[grupo.key]">
                      <tr
                        :key="grupo.key + '-' + row.item.account_id"
                        :style="row.hasChildren || row.hasConceptos ? 'cursor:pointer' : ''"
                        @click="(row.hasChildren || row.hasConceptos) && toggle(row.item.account_id)"
                      >
                        <td>{{ row.item.code }}</td>
                        <td :style="{ paddingLeft: 16 + row.depth * 24 + 'px' }">
                          <v-icon v-if="row.hasChildren || row.hasConceptos" small class="mr-1">{{ row.expanded ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                          <span :class="{ 'font-weight-bold': row.hasChildren }">{{ row.item.name }}</span>
                        </td>
                        <td class="text-right" :class="{ 'font-weight-bold': row.hasChildren }">{{ formatUtils.formatPrice(row.item.importe) }}</td>
                      </tr>

                      <tr
                        v-for="k in row.expanded ? row.item.conceptos : []"
                        :key="grupo.key + '-' + row.item.account_id + '-' + k.concepto_id"
                      >
                        <td></td>
                        <td :style="{ paddingLeft: 16 + (row.depth + 1) * 24 + 'px' }" class="grey--text">{{ k.name }}</td>
                        <td class="text-right grey--text">{{ formatUtils.formatPrice(k.importe) }}</td>
                      </tr>
                    </template>

                    <tr v-if="data[grupo.key].cuentas.length === 0" :key="grupo.key + '-e'">
                      <td colspan="3" class="text-center grey--text py-2">Sin movimientos.</td>
                    </tr>

                    <tr :key="grupo.key + '-t'">
                      <td colspan="2" class="font-weight-bold">{{ grupo.total_title }}</td>
                      <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data[grupo.key].total) }}</td>
                    </tr>
                  </template>

                  <tr :class="data.es_ganancia ? 'green lighten-5' : 'red lighten-5'">
                    <td colspan="2" class="font-weight-bold">{{ data.es_ganancia ? "GANANCIA DEL PERÍODO" : "PÉRDIDA DEL PERÍODO" }}</td>
                    <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.resultado) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <div v-else class="pa-6 text-center grey--text">Elegí emisor y período, y presioná Buscar.</div>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import { formatUtils } from "@/libs/utils/formatUtils";

import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import CuentasTreeMixin from "@/mixins/CuentasTreeMixin.vue";
import Title from "@/components/Title.vue";

export default {
  components: { Title },
  mixins: [GenericMixin, RolMixin, ExportMixin, CuentasTreeMixin],
  data() {
    return {
      page_title: "Estado de Resultados",
      formatUtils: formatUtils,
      data: null,
      desde_menu: false,
      hasta_menu: false,
      desde_selected: new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), 11, 31).toISOString().slice(0, 10),
      emitters: [],
      emitter_selected: null,
      cost_centers: [],
      cost_center_selected: null,
      grupos: [
        { key: "ingresos", title: "INGRESOS", total_title: "Total Ingresos" },
        { key: "egresos", title: "EGRESOS", total_title: "Total Egresos" },
      ],
    };
  },
  computed: {
    // Árboles sobre los que opera CuentasTreeMixin (Expandir todo / allExpanded).
    cuentasTrees() {
      return this.data ? [this.data.ingresos.cuentas, this.data.egresos.cuentas] : [];
    },
    // Aplana cada árbol (data[grupo].cuentas) respetando `expanded`, para poder
    // iterarlo con un solo v-for por fila (cuentas padre e hijas al mismo nivel de tabla).
    rowsByGrupo() {
      if (!this.data) return { ingresos: [], egresos: [] };
      return {
        ingresos: this.flattenCuentas(this.data.ingresos.cuentas),
        egresos: this.flattenCuentas(this.data.egresos.cuentas),
      };
    },
  },
  mounted() {
    this.loadCombos();
  },
  methods: {
    loadCombos() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.emitters = response.result || [];
        if (this.emitters.length > 0) {
          this.emitter_selected = this.emitters[0];
          this.filter();
        }
      });
      generalService.filter({}, Constant.SECTION_COSTS_CENTERS).then((response) => {
        this.cost_centers = response.result;
      });
    },
    getFilterParams() {
      return {
        emitter: this.emitter_selected != null ? this.emitter_selected.id : null,
        from: this.desde_selected,
        to: this.hasta_selected,
        cost_center: this.cost_center_selected != null ? this.cost_center_selected.id : null,
      };
    },
    filter() {
      if (this.emitter_selected == null) return;
      this.loading = true;
      generalService
        .query(this.getFilterParams(), Constant.SECTION_REPORT_ESTADO_RESULTADOS)
        .then((response) => {
          if (!response.status) {
            this.$toast.error(response.msg, "Error");
            return;
          }
          this.data = response.result;
          this.resetExpanded();
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading = false));
    },
    exportFile() {
      const param = this.getFilterParams();
      param.export = true;
      this.exportExcel(Constant.SECTION_REPORT_ESTADO_RESULTADOS, param, "Estado-de-Resultados.xlsx");
    },
  },
};
</script>
